import { ClickedPlace } from "@components/Seatmap/Seatmap";
import styles from "./SelectPlaceTypeModal.module.scss";
import { Button, Text, Modal, ModalButtons } from "@eventsquare/uikit";
import {
  Form,
  FormFieldset,
  FormGroup,
  FormSelect,
} from "@eventsquare/uikit/forms";

import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface SelectPlaceTypeModalProps {
  clickedPlaceWithTypes: ClickedPlace | null;
  closeModal: () => void;
  deselectPlace: (placeId: string) => void;
  modifyCart: (
    place: string,
    typeId: string,
    action: "select" | "deselect",
  ) => void;
}

interface SelectPlaceTypeFormValues {
  selected_type: string;
}

export const SelectPlaceTypeModal = (props: SelectPlaceTypeModalProps) => {
  const {
    // clickedPlace, showModal,
    clickedPlaceWithTypes,
    closeModal,
    deselectPlace,
    modifyCart,
  } = props;

  const [selectedType, setSelectedType] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  const { t } = useTranslation("components_select_place_type_modal");

  useEffect(() => {
    if (!clickedPlaceWithTypes) {
      setSelectedType("");
      return;
    }

    setSelectedType(clickedPlaceWithTypes.types[0].id);
  }, [clickedPlaceWithTypes]);

  const handleSubmit = async (values: SelectPlaceTypeFormValues) => {
    console.log("Selected type:", values.selected_type);
    if (!clickedPlaceWithTypes) return;
    setLoading(true);
    await modifyCart(
      clickedPlaceWithTypes?.place,
      values.selected_type,
      "select",
    );
    setLoading(false);
    close();
  };

  const close = () => {
    if (loading) return;
    if (clickedPlaceWithTypes) deselectPlace(clickedPlaceWithTypes.place);
    closeModal();
  };

  const initialValues: SelectPlaceTypeFormValues = {
    selected_type: selectedType,
  };

  if (!clickedPlaceWithTypes) return null;

  return (
    <Modal isVisible={!!clickedPlaceWithTypes} closeModal={close}>
      <div className={styles.selectPlaceTypeModal}>
        <Form onSubmit={handleSubmit} initialValues={initialValues}>
          <FormFieldset disabled={loading}>
            <FormGroup>
              <Text variant="h3" color="info" noMargin>
                {t("title")}
              </Text>
            </FormGroup>
            <FormGroup>
              <FormSelect
                name="selected_type"
                placeholder={t("placeholder")}
                options={clickedPlaceWithTypes?.types.map((type) => {
                  return {
                    value: type.id,
                    label: type.name,
                  };
                })}
              />
            </FormGroup>
          </FormFieldset>
          <ModalButtons>
            <Button type="submit" block loading={loading}>
              {t("button")}
            </Button>
          </ModalButtons>
        </Form>
      </div>
    </Modal>
  );
};
